export function createQueryKeys<TFilter extends object | undefined = object>(
    baseKey: string
) {
    const base = [baseKey] as const;

    return {
        /** ['deviceType'] */
        all: base,

        /**
         * ['deviceType','list']                khi không có filter
         * ['deviceType','list', {…filter…}]    khi có filter
         */
        list: (filter?: TFilter) =>
            filter
                ? ([...base, 'list', filter] as const)
                : ([...base, 'list'] as const),

        /**
         * ['deviceType','detail', id]                  khi không có params
         * ['deviceType','detail', id, {…params…}]      khi có params
         */
        detail: <TParams extends object = object>(
            id: string | number,
            params?: TParams
        ) =>
            params
                ? ([...base, 'detail', id, params] as const)
                : ([...base, 'detail', id] as const),

        /** ['deviceType', ...args] */
        custom: (...args: (string | number | object)[]) =>
            [...base, ...args] as const,
    };
}
